"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLISearchKeywords = exports.maxProfileAgeResponseReceivedInDays = exports.maxProfileAgeToAddInDays = void 0;
const lodash_1 = require("lodash");
const person_1 = require("./person");
exports.maxProfileAgeToAddInDays = 1800;
exports.maxProfileAgeResponseReceivedInDays = 180;
function getLISearchKeywords(profiles) {
    const escapeChars = (str) => '"' + str.replace(/"/g, '\\"').replace(/\(/g, '\\(').replace(/\)/g, '\\)') + '"';
    const keywords = profiles.map((p) => {
        var _a, _b;
        if (!p)
            return null;
        const extractedName = (_b = (_a = (0, person_1.extractName)({ full: p.fullName })) === null || _a === void 0 ? void 0 : _a.full) !== null && _b !== void 0 ? _b : p.fullName;
        const name = escapeChars(extractedName);
        const posCompanies = (0, lodash_1.uniq)(p.positions.map((pos) => pos.companyName).filter((c) => !!c)).slice(0, 2);
        const companies = `(${posCompanies.slice(0, 2).map(escapeChars).join(' OR ')})`;
        const eduSchools = (0, lodash_1.uniq)(p.educations.map((edu) => edu.schoolName).filter((s) => !!s)).slice(0, 2);
        const schools = `(${eduSchools.slice(0, 2).map(escapeChars).join(' OR ')})`;
        if (posCompanies.length === 0 || eduSchools.length === 0)
            return null;
        return `(${[name, companies, schools].join(' AND ')})`;
    });
    return keywords.filter((k) => !!k).join(' OR\n');
}
exports.getLISearchKeywords = getLISearchKeywords;
//# sourceMappingURL=profile.js.map